import React from 'react';
import { withTranslation } from 'react-i18next';
import { type WithTranslation } from '../../../types/common.types';
import { AiTagsProps } from '../../../types/sidePanel.types';
import ImgIconComp from '../../../../components/imgcomp';

export default withTranslation()(class AiTagsComp extends React.Component<WithTranslation<AiTagsProps>> {
  constructor(props: WithTranslation<AiTagsProps>) {
    super(props);
    this.registerAutoComplete = this.registerAutoComplete.bind(this);
  }

  componentDidMount() {
    if (this.props.tagAccess) {
      setTimeout(() => this.registerAutoComplete(), 100);
    }
  }

  registerAutoComplete() {
    const _this = this;
    const { t } = this.props;
    ($(_this.refs.addTagAi) as any)
      .autocomplete({
        source(request: { term: any; }, response: (arg0: any[]) => void) {
          $.ajax({
            url: `${wbConfig.baseUrl}/activity/findTags`,
            type: "get",
            data: { term: request.term, teamId: "" },
            dataType: "json"
          })
            .done(result => {
              let data = result.data;
              const dataCount = [];
              const findCount = [];
              const dataCountTeam = [];
              const findCountTeam = [];
              let transformed: any[] = [];
              if (data != null && data != "") {
                const re = ($ as any).ui.autocomplete.escapeRegex(request.term);
                const matcher = new RegExp(`^${re}$`, "i");
                transformed = $.map(data, (value, key) => {
                  if (value.type == 1) {
                    if (!matcher.test(value.label)) {
                      findCount.push(key);
                    }
                    dataCount.push(key);
                  }
                  if (value.type == 2) {
                    if (!matcher.test(value.label)) {
                      findCountTeam.push(key);
                    }
                    dataCountTeam.push(key);
                  }
                  return {
                    label: value.label,
                    value: value.label,
                    id: value.tagId,
                    teamId: value.teamId,
                    type: value.type
                  };
                });
              }
              const addUserTeamTags: any = {};
              if (
                dataCount.length == findCount.length ||
                (data == null || data == "")
              ) {
                addUserTeamTags.personal = {
                  label: t("+ New Personal Tag"),
                  value: request.term,
                  id: "newTag",
                  teamId: null,
                  type: 1
                };
              }
              if (
                dataCountTeam.length == findCountTeam.length ||
                (data == null || data == "")
              ) {
                addUserTeamTags.team = {
                  label: t("+ New Team Tag"),
                  value: t("+ New Team Tag"),
                  id: "newTag",
                  teamId: null,
                  type: 2
                };
              }
              transformed = $.extend({}, transformed, addUserTeamTags);
              response(transformed);
            })
            .fail(() => {
              response([]);
            });
        },
        select(event: any, ui: { item: { id: string; type: string; label: any; teamId: string }; }) {
          const tagId = ui.item.id;
          const tagType = ui.item.type;
          let selectedLabel = ui.item.label;
          const exTagId = _this.props.aiTags.find((item: { id: string; }) => item.id == tagId);
          if (exTagId) {
            return false;
          }
          if (tagId == "newTag") {
            selectedLabel = $(_this.refs.addTagAi).val();
          }
          const { teamId } = ui.item;
          const aiId = _this.props.aiDet.id;
          $.post(
            `${wbConfig.baseUrl}/activity/addTagToAi`,
            {
              tag_id: tagId,
              act_id: aiId,
              team_id: teamId,
              term: selectedLabel,
              tagType,
              wsBoardView: true
            },
            (data, status) => {
              if (status == "success") {
                _this.props.addTagToStateList(data.data);
              }
            }
          );

          $(_this.refs.addTagAi).val("");
          return false;
        },
        focus(event: any, ui: any) {
          return false;
        },
        open(event: any, ui: any) {
          $(this)
            .data("ui-autocomplete")
            .menu.element.addClass("board-tag-autocomplete");
        }
      })
      .data("ui-autocomplete")._renderItem = function (ul: string | Element | JQuery<HTMLElement> | DocumentFragment | (Element | DocumentFragment)[], item: { id: string; type: string; label: string; }) {
        let classVal = "";
        if (item.id == "newTag") {
          classVal = "newTag";
        }
        return $("<li></li>")
          .data("item.autocomplete", item)
          .append(
            `<a class='truncateText type-${item.type} ${classVal}'>${item.label}</a>`
          )
          .appendTo(ul);
      };
  }

  render() {
    const { t } = this.props;
    return (
      <div className="wsBoardAiTagsWrapper pL10">
        {this.props.tagAccess && (
          <div className="wsBoardAddTagDiv">
            <input
              type="text"
              className="wsBoardAddTagBox"
              ref="addTagAi"
              placeholder={t("Type to add a new tag")}
            />
          </div>
        )}
        <div className="wsBoardTagListDiv">
          {this.props.aiTags != null && Object.keys(this.props.aiTags).length
            ? Object.keys(this.props.aiTags).map((item, index) => (
              <div key={this.props.aiTags[item].id}
                className={
                  this.props.aiTags[item].type == 2
                    ? "wsBoardTagDiv tagDiv teamTagBgcolor"
                    : "wsBoardTagDiv tagDiv personalTagBgcolor"
                }
              >
                <div
                  className={
                    this.props.aiTags[item].type == 2
                      ? "displayCell wsBoardTagTypeDiv teamTagBgImage"
                      : "displayCell wsBoardTagTypeDiv personalTagBgImage"
                  }
                />
                <div className="displayCell wsBoardTagNameDiv">
                  <div className="truncateText wsBoardTagName">
                    {this.props.aiTags[item].name}
                  </div>
                </div>
                <div
                  className="clickable displayCell wsBoardTagCloseDiv clickable"
                  data-perm-value={this.props.tagAccess}
                  onClick={() =>
                    this.props.removeItemFromList(
                      "aiTags",
                      this.props.aiTags[item].id,
                      this.props.tagAccess
                    )
                  }
                >
                  <ImgIconComp id="close" width="8" height="8" />
                </div>
              </div>
            ))
            : ""}
        </div>
      </div>
    );
  }
});
